import React from 'react'
import { Image, Paragraph, Separator } from '@fs/zion-ui'

const NoTranscriptMessage = ({ message, searchRecordImg }) => (
  <>
    <Image src={searchRecordImg} alt={message} />
    <Separator />
    <Paragraph data-testid="trascript-not-available" size="sm" centered>
      {message}
    </Paragraph>
  </>
)

export default NoTranscriptMessage
